import $axios from '../config.js'
import { url } from '../api_urls/eventClient.js'
// 获取列表
export function findList (params) {
  return $axios.post(url.getListData, params)
}
// 获取页面顶部信息
export function getLastUpdateTime (params) {
  return $axios.post(url.getLastUpdateTime, params)
}
// 获取详情
export function getDetail (params) {
  return $axios.post(url.getDetail, params)
}
// 获取Concept列表
export function getConceptList (params) {
  return $axios.post(url.getConceptList, params)
}
// 获取Trend列表
export function getTrendList (params) {
  return $axios.post(url.getTrendList, params)
}
// 获取BasfProduct分类
export function getBasfProductSegment (params) {
  return $axios.post(url.getBasfProductSegment, params)
}
// 获取Formulation分类
export function getFormulationSegment (params) {
  return $axios.post(url.getFormulationSegment, params)
}
// 获取Formulation列表
export function getFormulationList (params) {
  return $axios.post(url.getFormulationList, params)
}
// 获取basf product列表
export function getBasfProductList (params) {
  return $axios.post(url.getBasfProductList, params)
}
// 评论
export function setComment (params) {
  return $axios.post(url.setComment, params)
}
// 获取keyword
export function getKeywordList (params) {
  return $axios.post(url.getKeywordList, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/eventClient.js